export default __webpack_public_path__ + "static/media/push45.4b765730.gif";